export default __webpack_public_path__ + "static/cardsRowImg1Full-e86c0c41acb6c929074b4a89689e9d36.png";